export * from './lib/soaking-material-inventory';
